import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Weather from '../components/Weather';

const cities = [
    /*{name: 'Istanbul', woeid: 2344116},*/
    {name: 'Athens', woeid: 946738},
    {name: 'Beijing', woeid: 2151330},
    {name: 'Berlin', woeid: 638242},
    {name: 'Cairo', woeid: 1521894},
    {name: 'London', woeid: 44418},
    {name: 'Madrid', woeid: 766273},
    {name: 'Moscow', woeid: 2122265},
    {name: 'New Delhi', woeid: 28743736},
    {name: 'New York', woeid: 2459115},
    {name: 'Paris', woeid: 615702},
    {name: 'Sydney', woeid: 1105779},
    /*{name: 'Helsinki', woeid: 565346},
    {name: 'Dublin', woeid: 560743},
    {name: 'Vancouver', woeid: 9807}*/
];

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            text: ''
        };
    }

    handleOnClick = () => {
        this.setState({redirect: true});
    }

    handleInput = (evt) => {
        this.setState({text: evt.target.value});
    }

    render() {
        if ( this.state.redirect ) {
            // redirect and update url
            return (<Redirect push to={"/search/"+encodeURIComponent(this.state.text.toLowerCase())} />);
        }
        return (
            <div className="page page-home">
                <h2 className="page-header">Weather at a Glance</h2>
                <div className="search-box">
                    <input type="text" placeholder="search.." value={this.state.text} onChange={this.handleInput} />
                    <button type="button" onClick={this.handleOnClick}>Search!</button>
                </div>
                {cities.map(city => <Weather key={'weather_for_'+city.woeid} city={city.name} woeid={city.woeid} />)}
            </div>
        );
    }
}

export default HomePage;
